<template>
  <div class="product-service-wrap">
    <section class="banner bgs-cover bgp-c">
      <div class="w-1000 h-100p m-a p-r">
        <h1 class="m-0 fs-50 fw-700 c-fff c-c p-a">Product Service</h1>
      </div>
    </section>
    <div class="crumb w-1000 m-a d-f jc-fs ai-c ff-asl fs-16">
      <a class="c-666" href="/" one-link-mark="yes">Home</a><span class="c-ccc"></span
      ><a class="c-666" href="support" one-link-mark="yes">Support Center</a><span class="c-ccc"></span
      ><a class="c-666 ff-as" one-link-mark="yes">Product Service</a>
    </div>
    <div class="cascader-wrap">
      <Cascader
        @on-change="chooseCascader"
        placeholder="Please select"
        :data="cascaderData"
        v-model="chooseData"
      ></Cascader>
    </div>
    <section class="area-faq">
      <div class="w-1000 m-a">
        <div v-show="showStatus === 1" class="no-content-tip c-666 fs-20 ta-c" style="">No relevant content</div>
        <h2 v-show="showStatus === 2" class="m-0 ta-c fs-40 c-000">FAQ</h2>
        <div v-show="showStatus === 2" class="c-666 fs-20 ta-c">All you wanna know about FJD products</div>
        <Collapse v-show="showStatus === 2" :value="collapseName" simple class="faq-list">
          <Panel :name="`${item.feedbackId}`" v-for="item in faqList" :key="item.feedbackId">
            <span class="c-333 fs-20 fw-700 lh-15">
              {{ item.question }}
            </span>
            <div slot="content" class="answer fs-16 lh-15" style="">
              {{ item.answer }}
            </div>
          </Panel>
        </Collapse>
        <div
          v-show="isShowAllCollapseIcon"
          @click="showAllFaq"
          class="triangle-icon triangle-icon-000 d-n m-a c-p tr-180"
          id="more-faq"
          style="display: block"
        ></div>
        <section v-show="showStatus === 3" class="area-download mt-120 mb-120">
          <div class="w-1000 m-a">
            <h2 class="m-0 ta-c fs-40">Download</h2>
            <div class="download-content c-666 fs-16">
              <div class="download-hd d-f jc-sb ai-c c-333 fs-20">
                <span>File name</span>
                <span>Describe</span>
                <span>Operate</span>
              </div>
              <div v-for="downloadItem in downloadData" :key="downloadItem.productId" class="download-bd">
                <div class="download-list ov-h d-f jc-sb ai-c">
                  <span>{{ downloadItem.fileName }}</span>
                  <span>{{ downloadItem.describe }}</span>
                  <span
                    ><a :href="downloadItem.apkUrl" download=""><i class="d-b m-a download-icon"></i></a
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        cascaderData: [],
        chooseData: [],
        activeIndex: false,
        faqListData: [],
        productId: '',
        noData: true, // 默认无数据
        showStatus: 1, // 1 代表无数据 2 问答列表 3 下载
        // 获取数据之后 是否显示全部 当点击按钮之后才显示全部
        isShowAllCollapseIcon: false,
        faqList: [],
        // 全部
        allFaqList: [],
        downloadData: [],
        collapseName: []
      }
    },
    created() {},
    mounted() {
      this.getProductList()
    },
    methods: {
      async getProductList() {
        const { data } = await this.$api.common.getProductList()
        data.forEach((item) => {
          const childrenArr = item.productName.split(',')
          const children = []
          childrenArr.forEach((childItem) => {
            const [label, value] = childItem.split('_')
            children.push({
              value,
              label
            })
          })
          this.cascaderData.push({
            value: item.productTypeOverseas,
            label: item.productTypeOverseas,
            children
          })
        })
        console.log('[ data ] >', this.cascaderData)
      },
      async getFaqTableList(productId) {
        const { data } = await this.$api.common
          .getFaqTableList({
            productId,
            language: 'en-US'
          })
          .catch(() => {
            this.noData = true
          })
        if (data[0].length) {
          this.showStatus = 2
          this.faqList = data[0].slice(0, 4)
          if (data[0].length > 4) {
            this.isShowAllCollapseIcon = true
          }
          // 展开 面板
          this.faqList.forEach((item) => {
            this.collapseName.push(item.feedbackId)
          })

          this.allFaqList = data[0]
          console.log('this.faqList=>', this.faqList)
        } else if (data[1].length) {
          this.showStatus = 3
          this.downloadData = data[1]
          this.isShowAllCollapseIcon = false
        } else {
          this.showStatus = 1
          this.isShowAllCollapseIcon = false
        }

        // this.faqListData = data && data[0]
        // this.noData = data[0].length === 0
        // console.log('[ data ] >', data)
      },
      chooseCascader(val, selectedData) {
        console.log('[ val,selectedData ] >', val, selectedData)
        this.productId = val && val[1]
        this.getFaqTableList(this.productId)
      },
      showAllFaq() {
        this.isShowAllCollapseIcon = false
        this.faqList = this.allFaqList
        this.allFaqList.forEach((item, idx) => {
          if (idx > 3) {
            this.collapseName.push(item.feedbackId)
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .product-service-wrap {
    margin-top: 3.958vw;
    .banner {
      height: 3.6rem;
      background-image: url('@/assets/images/support_0402/support_banner.jpg');
    }

    .crumb {
      padding: 68px 0 100px;
    }

    .cascader-wrap {
      width: 640px;
      margin: 0 auto;
      // margin-top: 0.6rem;
      :deep(.ivu-select-dropdown) {
        max-height: 250px;
      }
      /* 级联选择器 */
      :deep(.ivu-input) {
        height: 50px;
        padding: 0 35px 0 15px;
        border-color: #999;
        border-width: 1px;
        color: #333;
        padding-left: 0.24rem;
        font-size: 0.18rem;
        &:focus {
          box-shadow: none;
        }
      }
      :deep(.ivu-cascader-arrow) {
        font-size: 0.24rem;
        right: 0.16rem;
      }
      :deep(.ivu-cascader-transfer .ivu-cascader-menu-item) {
        line-height: 40px;
        cursor: pointer;
        border-radius: 4px;
        padding: 0 10px;
      }
      :deep(.ivu-cascader .ivu-cascader-menu-item) {
        color: #999;
        line-height: 40px;
        cursor: pointer;
        border-radius: 4px;
        padding: 0 10px;
        &:hover {
          color: #333;
        }
      }
      :deep(.ivu-cascader-menu) {
        min-width: 230px;
        height: 250px;
      }
      :deep(.ivu-cascader-menu .ivu-cascader-menu-item-active) {
        color: #333;
      }
    }

    .area-faq {
      padding: 70px 0 20px;
      h2 {
        margin-bottom: 15px;
      }
      :deep(.ivu-collapse) {
        border: none;
      }
      :deep(.ivu-collapse-item) {
        padding: 25px 0;
        border: none;
        border-bottom: 1px solid #d2d2d2;
      }

      :deep(.ivu-collapse > .ivu-collapse-item > .ivu-collapse-header) {
        display: flex;
        align-items: center;
        flex-direction: row-reverse;
        justify-content: space-between;
      }
      :deep(.ivu-collapse > .ivu-collapse-item > .ivu-collapse-header > i) {
        transform: rotate(180deg);
      }
      :deep(.ivu-collapse > .ivu-collapse-item.ivu-collapse-item-active > .ivu-collapse-header > i) {
        transform: rotate(0);
      }
      :deep(.ivu-icon-ios-arrow-forward:before) {
        content: ' ';
        display: block;
        width: 20px;
        height: 20px;
        background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3Cfilter color-interpolation-filters='auto' id='a'%3E%3CfeColorMatrix in='SourceGraphic' values='0 0 0 0 0.462745 0 0 0 0 0.462745 0 0 0 0 0.462745 0 0 0 1.000000 0'/%3E%3C/filter%3E%3C/defs%3E%3Cpath d='M0 8.8L8.648.385a1.581 1.581 0 0 1 .001 2.267l-7.483 7.28L0 8.8zm1.173-1.14l7.585 7.377a1.583 1.583 0 0 1-.001 2.27L.01 8.793l1.165-1.134-.002.002z' fill='%23515151' fill-rule='nonzero' transform='rotate(90 6.538 11.923)' filter='url(%23a)'/%3E%3C/svg%3E");
      }
      .no-content-tip {
        min-height: 400px;
        // padding-top: 100px;
      }
    }
  }
  // 内容下载
  /* area-download */
  .area-download h2 {
    color: #333;
  }
  .download-content {
    margin-top: 60px;
  }
  .download-bd {
    border: 1px solid #e9e9e9;
    border-top: none;
  }
  .download-hd {
    background-color: #f7f7f7; /*box-shadow: 0px 3px 4px 2px rgba(0, 0, 0, 0.04), 0px 3px 6px -5px rgba(0, 0, 0, 0.04)*/
  }
  .download-list:hover {
    color: #333;
  }
  .download-list .download-icon:hover {
    background-image: url("data:image/svg+xml,%3Csvg width='22' height='20' viewBox='0 0 22 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.895 18.684H3.158a1.842 1.842 0 0 1-1.842-1.842v-2.105a.79.79 0 1 1 1.579 0v2.105c0 .145.118.263.263.263h14.737a.263.263 0 0 0 .263-.263v-2.105a.79.79 0 1 1 1.579 0v2.105a1.842 1.842 0 0 1-1.842 1.842zm-7.369-5.147a.79.79 0 0 1-.79-.8V2.21a.79.79 0 0 1 1.58 0v10.526a.79.79 0 0 1-.79.8zm0 1.352a.795.795 0 0 1-.558-.231L4.705 9.395a.784.784 0 0 1 0-1.116.795.795 0 0 1 1.116 0l5.263 5.263a.784.784 0 0 1 0 1.116.795.795 0 0 1-.558.231zm0 0a.795.795 0 0 1-.79-.789c0-.21.083-.41.232-.558l5.264-5.263a.795.795 0 0 1 1.115 0 .784.784 0 0 1 0 1.116l-5.263 5.263a.795.795 0 0 1-.558.231z' fill='%23EAA10F' fill-rule='nonzero'/%3E%3C/svg%3E");
  }
  .download-hd,
  .download-list {
    padding: 0 20px;
  }
  .download-hd,
  .download-bd,
  .download-list {
    height: 52px;
  }
  .download-content > div span:nth-of-type(1) {
    width: 70%;
  }
  .download-content > div span:nth-of-type(2) {
    width: 20%;
  }
  .download-content > div span:nth-of-type(3) {
    width: 10%;
  }
  .download-icon {
    width: 22px;
    height: 20px;
  }
  .faq-list {
    padding: 60px 0;
  }
  .no-content-tip {
    min-height: 400px;
    padding-top: 100px;
  }
</style>
